import React, { useState, useEffect } from "react";

import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import GenericDeleteModal from "../../../../modal/generic-delete-modal";

function ModelerModalDeleteForm({ handleDelete }) {
  const [open, setOpen] = useState(false);

  const onDelete = () => {
    handleDelete && handleDelete();
    setOpen(false);
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    open && (
      <Provider>
        <GenericDeleteModal
          deleteConfirmationText={language.deleteForm}
          deleteBtnCancelText={language.cancel}
          deleteBtnConfirmText={language.delete}
          deleteAction={onDelete}
          handleDialogClose={() => setOpen(false)}
        />
      </Provider>
    )
  );
}

export default ModelerModalDeleteForm;
